<app-breadcrumb [items]="breadcrumbs"></app-breadcrumb>
<app-content-card cardTitle="Spiderweb" [pdfCenter]="isPdfExport()" [removeTopPadding]="true">
  <p>
    Door de huidige en toekomstige beoordeling te visualiseren in een spiderweb, wordt zichtbaar op welke thema's er opgaven zijn richting de toekomst.
    Onderstaande spiderweb toont de weergave van de beoordeling op basis van consensus.
  </p>
  <div class="content-container">
    <div class="graph-container">
      <div #chart class="graph"></div>
      <ul [ngClass]="numberOfItemsClass" class="circle-container overlap-icons">
        @for (item of currentSituationItems; track item) {
          <li>
            <button class="accessibility-button" (click)="iconClicked(item.itemId)" [ngClass]="item.type.category + '-theme'">
              <app-custom-icon
                [customIcon]="item.type.icon"
                [ariaLabel]="item.type.name"
                [ngClass]="selectedItem?.currentItem?.itemId === item.itemId && !isPdfExport()? 'active' : ''"
              ></app-custom-icon>
            </button>
          </li>
        }
      </ul>
    </div>
    @if (selectedItem && !isPdfExport()) {
      <div class="info-container" [class]="getTheme(selectedItem.currentItem)">
        <h3 >{{translatedCategory}} - {{selectedItem.currentItem.type.name}}</h3>
        <h4>Huidige situatie</h4>
        <h5>Samenvattend statement</h5>
        <mat-form-field>
          @if (selectedItem.currentItem.summary) {
            <span
              [ngClass]="customIcon.class"
              >
              {{selectedItem.currentItem.summary}}
            </span>
          } @else {
            <span [ngClass]="customIcon.class">
              Er is geen samenvatting voor {{selectedItem.currentItem.type.name}} gegeven.
            </span>
          }
          <textarea matInput hidden disabled></textarea>
        </mat-form-field>
        <h5>Concluderend statement</h5>
        <mat-form-field>
          @if (selectedItem.currentItem.underpinning) {
            <span
              [ngClass]="customIcon.class"
              >
              {{selectedItem.currentItem.underpinning}}
            </span>
          } @else {
            <span [ngClass]="customIcon.class">
              Er is geen concluderend statement achter de consensus gezet van {{selectedItem.currentItem.type.name}}
            </span>
          }
          <textarea matInput hidden disabled></textarea>
        </mat-form-field>
        <br>
          <h4>Toekomstige situatie</h4>
          <h5>Samenvattend statement</h5>
          <mat-form-field>
            @if (selectedItem.futureItem.summary) {
              <span
                [ngClass]="customIcon.class"
                >
                {{selectedItem.futureItem.summary}}
              </span>
            } @else {
              <span [ngClass]="customIcon.class">
                Er is geen samenvatting voor {{selectedItem.futureItem.type.name}} gegeven.
              </span>
            }
            <textarea matInput hidden disabled></textarea>
          </mat-form-field>
          <h5>Concluderend statement</h5>
          <mat-form-field>
            @if (selectedItem.futureItem.underpinning) {
              <span
                [ngClass]="customIcon.class"
                >
                {{selectedItem.futureItem.underpinning}}
              </span>
            } @else {
              <span [ngClass]="customIcon.class">
                Er is geen concluderend statement achter de consensus gezet van {{selectedItem.futureItem.type.name}}
              </span>
            }
            <textarea matInput hidden disabled></textarea>
          </mat-form-field>
        </div>
      }
    </div>
  </app-content-card>
